
import { Loader2 } from "lucide-react";

interface SurveyLoadingProps {
  isRtl: boolean;
}

export const SurveyLoading = ({ isRtl }: SurveyLoadingProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background" dir={isRtl ? "rtl" : "ltr"}>
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        <p>Loading survey...</p>
      </div>
    </div>
  );
};
